import React from "react";
import { useLang } from "../contexts/LanguageContext";

/**
 * Premium continuous city ticker.
 * Lives OUTSIDE the Hero section so it's never affected by hero font-load reflow
 * or hero overflow-hidden clipping. Stable min-height prevents CLS.
 */
export default function CityTicker() {
  const { isAr } = useLang();
  const cities = isAr
    ? ["الرياض", "جدة", "المدينة", "الخبر", "العُلا"]
    : ["Riyadh", "Jeddah", "Madinah", "Khobar", "AlUla"];

  return (
    <div id="cities" className="city-ticker" data-testid="city-ticker" style={{ scrollMarginTop: '110px' }}>
      <div className="city-ticker-track">
        {[0, 1].map((half) => (
          <div className="city-ticker-group" key={half} aria-hidden={half !== 0}>
            {Array.from({ length: 4 }).flatMap((_, r) =>
              cities.map((city, i) => (
                <span className="city-ticker-item" key={`${half}-${r}-${i}`}>
                  <span className="city-ticker-dot" />
                  <span
                    className={`city-ticker-name ${isAr ? "font-cairo" : "font-display-en"}`}
                    dir={isAr ? "rtl" : "ltr"}
                  >
                    {city}
                  </span>
                </span>
              ))
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
